import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'lib-risk-template-management',
  templateUrl: './risk-template-management.component.html',
  styleUrls: ['./risk-template-management.component.scss']
})
export class RiskTemplateManagementComponent implements OnInit {

  public templateId: string;

  constructor(private activeRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.templateId = this.activeRoute.snapshot?.params?.id;
  }
}
